import React from 'react'
import { ApolloProvider } from '@apollo/client'
import { pickBy } from 'lodash'

import withEvents from 'hocs/withEvents'
import { getEventsQueryString } from 'models/events'

import Events from './Screen'

import {
  addApolloState,
  initializeApollo,
  useApollo,
} from '@/graphql/apolloClient'

const EventsHOC = Component => {
  const Wrapper = props => {
    const client = useApollo(props)

    return (
      <ApolloProvider client={client}>
        <Component {...props} />
      </ApolloProvider>
    )
  }

  Wrapper.getInitialProps = async ({ query }) => {
    const apolloClient = initializeApollo()

    const {
      eventType,
      latitude,
      location,
      longitude,
      page,
      search,
      startDate,
    } = query

    const filterObject = {
      eventType: eventType,
      location: location,
      startDate: startDate,
      latitude: latitude,
      longitude: longitude,
      guessLocation: (!latitude || !longitude) && false,
    }

    const filterBy = search || getEventsQueryString(pickBy(filterObject))

    return addApolloState(apolloClient, {
      filterBy,
      page,
    })
  }

  return Wrapper
}

export default withEvents(EventsHOC(Events))
